import { ErrorMessage, Field } from "formik";
import React from "react";

const DropdownForm = ({
  touched,
  error,
  dataToDrop,
  name,
  label,
  placeholder,
  gridStyle = "col-md-6",
  labelKey = "title",
  valueKey = "id",
  onChange,
  handleChange,
  required = true,
}) => {
  return (
    <div className={`${gridStyle} mb-3`}>
      <label className={`form-label ${required ? "required-label" : ""} `}>
        {label}
      </label>
      <Field
        onChange={(e) => {
          handleChange(e);
          if (onChange) {
            onChange(e);
          }
        }}
        as="select"
        name={name}
        className={`form-control ${
          touched && error ? "custom-invalid-input" : ""
        }`}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {dataToDrop.map((p, index) => (
          <option value={p[`${valueKey}`]} key={index}>
            {p[`${labelKey}`]}
          </option>
        ))}
      </Field>
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

export default DropdownForm;
